// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"476":"dee934f0","605":"dee934f0","868":"dee934f0"}[chunkId] + ".chunk.css";
};